import { Modal } from '@mantine/core';
import {
  AddBonusForm,
  AddDepositForm,
  AddProfitForm,
  AddTradingPlanForm,
  AddUserForm,
} from '../forms/Forms';

export const AddUserModal = ({ opened, close }) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size='lg'
      className='add-user-modal'
      overlayProps={{
        backgroundOpacity: 0.55,
      }}
    >
      <div className='title'>
        <h2>Add a user</h2>
      </div>

      <AddUserForm close={close} />
    </Modal>
  );
};

export const AddProfitModal = ({ opened, close, userId }) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size='lg'
      className='add-profit-modal'
      overlayProps={{
        backgroundOpacity: 0.55,
      }}
    >
      <div className='title'>
        <h2>Add Profit for this user</h2>
      </div>
      <AddProfitForm close={close} userId={userId} />
    </Modal>
  );
};

export const AddDepositModal = ({ opened, close, userId }) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size='lg'
      overlayProps={{
        backgroundOpacity: 0.55,
      }}
    >
      <div className='title'>
        <h2>Add Deposit for this user</h2>
      </div>
      <AddDepositForm close={close} userId={userId} />
    </Modal>
  );
};

export const AddBonusModal = ({ opened, close, userId }) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size='lg'
      className='add-bonus-modal'
      overlayProps={{
        backgroundOpacity: 0.55,
      }}
    >
      <div className='title'>
        <h2>Add Bonus for this user</h2>
      </div>
      <AddBonusForm close={close} userId={userId} />
    </Modal>
  );
};

export const AddTradingPlanModal = ({ opened, close }) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size='lg'
      className='add-user-modal'
      overlayProps={{
        backgroundOpacity: 0.55,
      }}
    >
      <div className='title'>
        <h2>Add a trading plan</h2>
      </div>

      <AddTradingPlanForm close={close} />
    </Modal>
  );
};
